











































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { component } from "../../api/component/component";
import { personnel } from "../../api/personnel/personnel";
import { workorder } from "../../api/workorder/workorder";
import { status } from "../../api/status/status";
import WorkOrderFilters from "../Filters/WorkOrderFilters.vue";
import Moment from "moment";
import { StringHelpers } from "../../api/helpers/StringHelpers";
@Component({
  name: "WorkOrderList",
  components: {
    WorkOrderFilters
  }
})
export default class WorkOrderList extends Vue {
  public workOrderList: any[] = [];
  public typeList: any[] = [];
  public statusList: any[] = [];
  public personnelList: any[] = [];
  public componentList: any[] = [];
  public loading: boolean = false;
  public filters: any = {};
  public userlevel: number = -1;
  public tableData: any[] = [];
  public listEnd: boolean = false;
  public index: number = 0;
  public checkEdit(row: any) {
    if (this.userlevel < 2 || row.date_closed == undefined) {
      return true;
    }
    if (
      new Date(row.date_closed).getTime() + 1000 * 60 * 60 * 24 * 11 >=
      new Date().getTime()
    ) {
      return true;
    }
    return false;
  }
  public getTotalHours(personList: any[], spec: number) {
    let hours = 0;
    for (const person of personList) {
      let p = this.personnelList.find(r => person.id == r.id);
      console.log(p.wo_specialty);
      console.log(spec);
      if (p.wo_specialty == spec || spec == 0) {
        hours = hours + this.getInterval(person.start_date, person.end_date);
      }
    }
    return hours;
  }
  public more() {
    let i = 1;
    while (i < 10) {
      this.tableData.push(
        this.workOrderList[this.workOrderList.length - this.index - 1]
      );
      this.index++;
      i++;
      if (
        this.workOrderList[this.workOrderList.length - this.index - 1] ==
        undefined
      ) {
        this.index--;
        this.listEnd = true;
        return;
      }
    }
  }
  public getInterval(d1: Date, d2: Date) {
    return (new Date(d2).getTime() - new Date(d1).getTime()) / (1000 * 60 * 60);
  }
  public async getPersonnelList() {
    await personnel
      .getAllPersonnel(
        this.$store.getters.getToken,
        this.$store.getters.getHost
      )
      .then(response => {
        response.json().then(resp => {
          this.personnelList = JSON.parse(JSON.stringify(resp));
          console.log(this.personnelList);
          this.getStatusList();
        });
      });
  }
  public getIssueDate(row: any, column: any): String {
    return Moment(row.date_issued).format("DD/MM/YYYY");
  }
  public getComponentName(row: any, column: any): String {
    console.log(row);
    let component = this.componentList.find(
      (obj: any) => obj.id === row.componentIds[0]
    );
    if (component != undefined) {
      return component.literal;
    }
    return "";
  }
  public getHall(row: any, column: any): String {
    console.log(row);
    let component = this.componentList.find(
      (obj: any) => obj.id === row.componentIds[0]
    );
    if (component != undefined) {
      return component.group1;
    }
    return "";
  }
  public getHours(row: any, column: any): String {
    let hours = 0;
    for (const p of JSON.parse(row.personnel)) {
      hours =
        hours +
        new Date(p.end_date).getTime() -
        new Date(p.start_date).getTime();
    }
    hours = hours / (1000 * 60 * 60);
    return hours.toString();
  }
  public getStatus(row: any, column: any): String {
    console.log(row);
    let status = this.statusList.find((obj: any) => obj.id === row.status);
    if (status != undefined) {
      return status.literal;
    }
    return "";
  }
  public chopDescription(row: any, column: any): String {
    return StringHelpers.shorten(row.name);
  }
  public getFilters() {
    let a = [];
    {
      for (const s of this.statusList) {
        a.push({ value: s.id, text: s.literal });
      }
    }
    return a;
  }
  public async search() {
    this.loading = true;
    this.listEnd = false;
    console.log(this.filters);
    if (this.filters.dateFrom === null) {
      delete this.filters.dateFrom;
    }
    if (this.filters.dateTo === null) {
      delete this.filters.dateTo;
    }
    await workorder
      .getSomeWorkOrders(
        this.$store.getters.getToken,
        this.filters,
        this.$store.getters.getHost
      )
      .then(response => {
        response.json().then((resp: any) => {
          this.workOrderList = JSON.parse(JSON.stringify(resp));
          this.tableData = this.workOrderList.slice(
            this.workOrderList.length - 10,
            this.workOrderList.length
          );
          this.index = 10;
          this.loading = false;
          console.log(JSON.parse(JSON.stringify(resp)));
        });
      });
  }
  public fillTable() {
    for (const w of this.workOrderList) {
      //w.personnel = JSON.parse(w.personnel);
    }
    console.log(this.workOrderList);
  }
  public workOrderStatus({
    row,
    rowIndex
  }: {
    row: number;
    rowIndex: number;
  }): String {
    return this.getStatus(row, 1);
  }
  public async created() {
    this.userlevel = this.$store.getters.getUserLevel;
    this.loading = true;
    await this.getPersonnelList();
  }
  public filterHandler(value: any, row: any, column: any) {
    const property = column["property"];
    return row[property] === value;
  }
  public handleClick(rowIndex: number, row: any) {
    row.personnel = JSON.stringify(row.personnel);
    this.$store.dispatch("updateCurrentObject", row);
    this.$store.dispatch("setCurrentId", row.id);
    this.$store.dispatch("updateCurrentComponent", "AddWorkOrder");
    this.$router.replace({
      name: "load"
    });
  }
  public filterDate(date: any) {
    if (date === undefined) {
      return "";
    }
    return Moment(date).format("DD/MM/YYYY");
  }
  public filterDateTime(date: any) {
    if (date === undefined) {
      return "";
    }
    return Moment(date).format("DD/MM/YYYY HH:mm");
  }
  public async getComponentList() {
    await component
      .getAllComponents(
        this.$store.getters.getToken,
        this.$store.getters.getHost
      )
      .then(response => {
        response.json().then(resp => {
          this.componentList = JSON.parse(JSON.stringify(resp));
          this.loading = false;
        });
      });
    this.fillTable();
  }
  public async getWorkOrderList() {
    await workorder
      .getAllWorkOrders(
        this.$store.getters.getToken,
        this.$store.getters.getHost
      )
      .then(response => {
        response.json().then((resp: any) => {
          this.workOrderList = JSON.parse(JSON.stringify(resp));
        });
      });
  }
  public async getStatusList() {
    await status
      .getAllStatuses(this.$store.getters.getToken, this.$store.getters.getHost)
      .then(response => {
        response.json().then((resp: any) => {
          this.statusList = JSON.parse(JSON.stringify(resp));
          this.getComponentList();
        });
      });
  }
  public async getWOTypeList() {
    await workorder
      .getAllTypes(this.$store.getters.getToken, this.$store.getters.getHost)
      .then(response => {
        response.json().then((resp: any) => {
          this.typeList = JSON.parse(JSON.stringify(resp));
        });
      });
  }
  public exportWO(row: any) {
    this.$store.dispatch("setCurrentId", row.aia_id);
    this.$store.dispatch("updateCurrentComponent", "DownloadWorkOrderDetails");
    this.$router.replace({
      name: "load"
    });
  }
  public async deleteWO(rowIndex: number, row: any) {
    await workorder
      .recycleWorkOrder(
        this.$store.getters.getToken,
        row.id,
        row.aia_id,
        this.$store.getters.getHost
      )
      .then(async r => {
        if (r.status == 400) {
          this.$message.error(r.error);
        } else {
          this.$message("Work Order Recycled");
          this.search();
        }
      });
  }
}
